
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference",
      function () {
        return require("private-next-pages/reference.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference"])
      });
    }
  